module.exports = __webpack_public_path__ + "static/media/community.604e9ee9.png";